var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributeCheckBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25600_346661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.8125C1.94062 2.8125 1.6875 3.06562 1.6875 3.375V14.625C1.6875 14.9344 1.94062 15.1875 2.25 15.1875H13.5C13.8094 15.1875 14.0625 14.9344 14.0625 14.625V3.375C14.0625 3.06562 13.8094 2.8125 13.5 2.8125H2.25ZM0 3.375C0 2.13398 1.00898 1.125 2.25 1.125H13.5C14.741 1.125 15.75 2.13398 15.75 3.375V14.625C15.75 15.866 14.741 16.875 13.5 16.875H2.25C1.00898 16.875 0 15.866 0 14.625V3.375ZM11.8477 7.34766L7.34766 11.8477C7.01719 12.1781 6.48281 12.1781 6.15586 11.8477L3.90586 9.59766C3.57539 9.26719 3.57539 8.73281 3.90586 8.40586C4.23633 8.07891 4.7707 8.07539 5.09766 8.40586L6.75 10.0582L10.6523 6.15234C10.9828 5.82188 11.5172 5.82188 11.8441 6.15234C12.1711 6.48281 12.1746 7.01719 11.8441 7.34414L11.8477 7.34766Z",
    fill: "#626F86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25600_346661"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H15.75V18H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeCheckBox);
export default __webpack_public_path__ + "static/media/attributeCheckBox.20d0f2ed22e63fe7137f643243e473f8.svg";
export { ForwardRef as ReactComponent };